export const configuration = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3003/api',
}
